import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const ChatLoadEndpointParams = z.object({
    /** ID of the chat to load events from */
    chatId: Id,
    /** Load events starting from this sequence index (for partial loading) */
    fromIndex: z.nullish(z.int32()),
});
export const ChatLoadEndpoint = defineEndpoint({
    name: 'ChatLoad',
    input: ChatLoadEndpointParams,
    /**
     * `null` when the chat does not exist or does not belong to the caller — the two are
     * deliberately indistinguishable (anti-enumeration), and the chat view renders its
     * not-found screen from it without catching an exception.
     */
    output: defineEndpoint.output(),
});
//# sourceMappingURL=ChatLoadEndpoint.js.map